<script>
    import { user } from '../../../store';
    import { createEventDispatcher } from 'svelte';
	import Chat from '../Chat/Chat.svelte'

    export let idea;
    export let authorData;
    export let docId;
	export let ideaImageAbsolutePath;
    
    const dispatch = createEventDispatcher();

    const closeModal = () => {
        dispatch('closeModal')
    }

</script>

<style lang="scss" src="./ModalChat.scss"></style>

<div class="ModalChat">
    {#if user}
        <Chat 
            {docId}
            {idea}
            {authorData}
            {ideaImageAbsolutePath}
            on:scrollModalToLatest>
        </Chat>
    {:else}
        <p class="messages">Login to see and join this ideas chat.</p>
        <button class="btn btn--primary" on:click={closeModal}>Login</button>
    {/if}
</div>    
